import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Modal from 'antd/lib/modal/Modal';
import { Button } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';
import completeImg from 'assets/images/pages/community/completeImg.webp';

type TAttachmentModalProps = {
  visible: boolean;
  setVisible: (x: any) => void;
  children: any;
  writePath?: string;
  ListPath: string;
};

const AttachmentModal = ({ visible, setVisible, children, writePath, ListPath }: TAttachmentModalProps) => {
  const history = useHistory();
  const handleCancel = () => {
    setVisible(false);
  };
  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      width={650}
      onCancel={handleCancel}
      title={
        <div style={{ marginTop: '20px' }}>
          <span
            style={{
              fontSize: '1.75rem',
              fontWeight: 'bolder',
            }}
          >
            후기 등록이 완료되었습니다!
          </span>
        </div>
      }
      footer={
        writePath ? (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              className='secondary'
              onClick={() => {
                handleCancel();
                history.push(writePath);
              }}
            >
              추가 후기 등록하기
            </Button>
            <Button
              type='primary'
              onClick={() => {
                handleCancel();
              }}
            >
              확인
            </Button>
          </div>
        ) : (
          <Link to={ListPath}>
            <Button type='primary'>확인</Button>
          </Link>
        )
      }
    >
      <ImgBox>
        <Img src={completeImg} alt='ticket' />
      </ImgBox>
      {children}
    </Modal>
  );
};

export default AttachmentModal;

const Title = styled.h1``;

const Img = styled.img`
  width: 100%;
`;

const ImgBox = styled.div`
  margin: 0 80px 20px 80px;
  @media screen and ${device.xs} {
    margin: 0 40px 20px 40px;
  }
`;

const Text = styled.p`
  font-size: 16px;
`;

const Notice = styled.p`
  color: #aeaeae;
`;
